let navigateFn = null;
let loggingOut = false;

export const setNavigate = (navigate) => {
  navigateFn = navigate;
};

// Call when the user deliberately logs out, so a 401 from a
// request that was already in-flight doesn't get mistaken for
// an expired session and redirect to the session-expired page.
export const markLoggingOut = () => {
  loggingOut = true;
  // Clear shortly after so a future real session expiry still shows the notice.
  setTimeout(() => {
    loggingOut = false;
  }, 3000);
};

export const redirectToLogin = () => {
  if (navigateFn) {
    navigateFn("/login");
  }
};

export const redirectToSessionExpired = () => {
  if (!navigateFn) return;
  if (loggingOut) {
    navigateFn("/login");
    return;
  }

  // Remember where the user was so login can return them there afterwards.
  const lastPath = window.location.pathname + window.location.search;
  const params = new URLSearchParams({ sessionExpired: "1" });
  if (lastPath && lastPath !== "/login") {
    params.set("redirect", lastPath);
  }
  navigateFn(`/login?${params.toString()}`);
};
